export const DATA_DEFINITION_PREFIX = 'DEF_';
export const DATA_DEF_SEP = '~~';
